import { PrinterOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons'
import { Tag, Form as AntForm, Select} from 'antd'
import axios from 'axios'
import { Button, DeleteButton, Form, Modal, Table, TableCard, Input, Drawer, Export, Map } from 'components'
import React, { useEffect, useState } from 'react'
import { FaPen, FaPlus, FaDownload, FaFilter } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import searchFields from './searchFields';
import dayjs from 'dayjs'
import { CgScrollH } from 'react-icons/cg'
import ExcelRender from 'modules/components/ExcelRender'
import { Option } from "antd/es/mentions";

const type = [
    {label:'Ажлахгүй', value: 'Ажлахгүй'},
    {label:'Бүтэн', value: 'Бүтэн'}, 
    {label: 'Хагас', value: 'Хагас'}, 
]

function Branch() {
    const [ data, setData ] = useState([])
    const [district, setDistrict] = useState([]);
    const [province, setProvince] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [ editData, setEditData ] = useState(null)
    const [ loading, setLoading ] = useState(false)
    const [ actionLoading, setActionLoading ] = useState(false)
    const [ showModal, setShowModal ] = useState(false)
    const [ filterOpen, setFilterOpen ] = useState(false);
    const [ currentPage, setCurrentPage ] = useState(0)
    const [ form ] = Form.useForm()
    const [ sector, setSector ] = useState([])
    const [ filterForm ] = Form.useForm();
    const [ openModalFileEdit, setOpenModalFileEdit ] = useState(false);
    const [ header, setHeader ] = useState([]);
    const [ cols, setCols ] = useState([]);
    const [ location, setLocation ] = useState([])
    // const location = [data[0].lat, data[0].lng];

    const status = [
        {label: <Tag color='error'>Дууссан</Tag>, value: 0},
        {label: <Tag color='processing'>Хэвийн</Tag>, value: 1}, 
        {label: <Tag color='success'>Сунгасан</Tag>, value: 2}, 
    ]

    useEffect(() => {
        getData()
        getProvince()
    },[])

    const getData = () => {
        setLoading(true)
        axios({
            method: 'get',
            url:'branches'
        }).then((res) => {
            setData(res.data) 
            const location = [res.data[0].lat, res.data[0].lng];
            // res.data.map((item) => tmp.push({ 
            //   location: [item[0]?.lat, item[0]?.lng],
          
            // }))
            setLocation(location)
           
        }).catch((err) => {
        }).finally(() => setLoading(false))
    }
    const getProvince = () => {
        axios({
            method: 'get',
            url: '/provinces',
        }).then((res) => {
            let tmp = res.data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
           
            setProvince(tmp);
        }).catch(() => {
        });
    };

    const getDistrict = () => {
        if (selectedProvince) {
            axios({
                method: 'get',
                url: `/districts?provinceid=${selectedProvince}`,
            })
            .then((res) => {
                let tmp = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setDistrict(tmp);
            })
            .catch(() => {});
        }
    };

    const handleProvinceChange = (value) => {
        setSelectedProvince(value);
    };

    useEffect(() => {
        getDistrict();
    }, [selectedProvince]);

    // console.log("selectedProvince",selectedProvince);

    const columns = [
        {
            title: '№',
            dataIndex: 'No',
            key: 'No',
            width: 50,
            align: 'center',
            cellRender: (e) => (
                <span>{e.rowIndex + currentPage+1}</span>
            )
        },
        {
            title: 'Салбарын нэр',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Утас',
            dataIndex: 'mobile',
            key: 'mobile',
        },
        
        {
            title: 'Хаяг',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: 'Цахим шуудан',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Тайлбар',
            dataIndex: 'descr',
            key: 'descr',
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: 90,
            cellRender: ({value,data}) => (
                <div className='action-cell flex items-center gap-2'>
                    <Button type='ghost' size='sm' icon={<FaPen/>} onClick={() => handleEditButton(data)}/>
                    <DeleteButton onClick={() => handleDelete(data)}/>
                </div>
            )
        }
    ]

    const fields = [
        {
            label: 'Нэр',
            name: 'name',
            rules: [{required: true, message: 'Нэр оруулна уу'}],
            className: 'col-span-12 mb-1',
            inputProps: {
            }
        },
        {
            label: 'Цахим шуудан',
            name: 'email	',
            rules: [{required: true, message: 'Цахим шуудан оруулна уу'}],
            className: 'col-span-12 mb-1',
            inputProps: {
            }
        },
        {
            label: 'Утас',
            name: 'mobile	',
            type: 'number', 
            rules: [{required: true, message: 'Утас оруулна уу'}],
            className: 'col-span-6 mb-1',
            inputProps: {
            }
        },
        // {
        //     label: 'Аймаг',
        //     name: 'province',
        //     type: 'number', 
        //     rules: [{required: true, message: 'Аймаг оруулна уу'}],
        //     className: 'col-span-6 mb-1',
        //     inputProps: {
        //     }
        // },
        // {
        //     label: 'Дүүрэг',
        //     name: 'district',
        //     type: 'number', 
        //     rules: [{required: true, message: 'Дүүрэг оруулна уу'}],
        //     className: 'col-span-6 mb-1',
        //     inputProps: {
        //     }
        // },


        {
            type:'component',
            component:(
                <Form.Item
                    label="Аймаг"
                    name="provinceid"
                    rules={[{ required: true, message: 'Аймаг оруулна уу' }]}
                    className="col-span-6 mb-1"
                >
                    <Select
                        placeholder="Аймаг оруулна уу"
                        onChange={handleProvinceChange}
                        value={selectedProvince}
                    >
                        {province.map((prov) => (
                            <Option key={prov.value} value={prov.value}>
                                {prov.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            )
        }, 
        {
            type:'component',
            component:(
                <Form.Item
                    label="Дүүрэг"
                    name="districtid"
                    rules={[{ required: true, message: 'Дүүрэг оруулна уу' }]}
                    className="col-span-6 mb-1"
                >
                    <Select placeholder="Дүүрэг сонгох">
                        {district.map((dist) => (
                            <Option key={dist.value} value={dist.value}>
                                {dist.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            )
        },
        {
            label: 'Хаяг',
            name: 'address',
            type: 'textarea',
            rules: [{required: true, message: 'Хаяг оруулна уу'}],
            className: 'col-span-12 mb-1',
            inputProps: {
            }
        }, 
        {
            label: 'Тайлбар',
            name: 'descr',
            type: 'textarea',
            // rules: [{required: true, message: 'тайлбар оруулна уу'}],
            className: 'col-span-12 mb-1',
            inputProps: {
            }
        },
        {
            type:'component',
            component:  (
                <Form.Item name='map' className='col-span-12'>
                    <Map className={'h-[230px]'} onChange={() => {}} disabled={false} />
                </Form.Item>
            )
        },
    ]

    const handleSubmit = (values) => {
        const { map, ...formData } = values;
        // console.log("values", map[0], map[1])
        setActionLoading(true);
        
        if (editData) {
            axios({
                method: 'put',
                url: `/branch`,
                data: {
                    ...formData, 
                    id: editData.id,
                    lng: map[0],
                    lat: map[1]
                }
            })
            .then((res) => {
                getData();
                handleCancel();
            })
            .catch((err) => {})
            .finally(() => {
                setActionLoading(false);
            });
        } else {
            axios({
                method: 'post',
                url: `/branch`,
                data: {
                    ...formData, 
                    lng: map[0],
                    lat: map[1]
                }
            })
            .then((res) => {
                getData();
                handleCancel();
            })
            .catch((err) => {})
            .finally(() => {
                setActionLoading(false);
            });
        }
    };
    
    const handleAddButton = (data) => {
        setEditData(null)
        setShowModal(true)
    }

    const handleEditButton = (data) => {
        setEditData(data)
        setShowModal(true)
    }

    const handleDelete = (data) => {
        setActionLoading(true)
        axios({
            method: 'delete',
            url: `/branch/${data.id}`,
        }).then((res) => {
            getData()
            handleCancel()
        }).catch((err) => {})
        .finally(() => {
            setActionLoading(false)
        })
    }
    
    const handleCloseModal = () => {
        setShowModal(false)
    }

    const handleCancel = () => {
        setShowModal(false)
        if(editData){
            setEditData(null)
        }else{
            form.resetFields()
        }
    }

    const handleFilterSubmit = (values) => {
        setLoading(true);
        axios({
            method: 'get',
            url: `/branch_search?name=${values.name}&purpose=${values.purpose}&departmentid=${values.departmentid}&requirements=${values.requirements}&positionid=${values.positionid}&job_time=${values.job_time}&end_date=${values.end_date}`,
        }).then((res) => {
            setData(res.data);
            setFilterOpen(false);
        }).catch((err) => {
        }).finally(() => setLoading(false))
    };
    
    const handleOpenFile = () => {
        setOpenModalFileEdit(true);
    };

    const handleCloseFileModal = () => {
        setOpenModalFileEdit(false);
    };
    const handleOpenModalFileEdit = () => {
        setOpenModalFileEdit(true);
    };

    const handleOpenCloseModalFileEdit = () => {
        setOpenModalFileEdit(false);
    };

    const handleFileSubmit = (values, method) => {
        let tmp = [];
        cols.forEach((item, i) => {
            if (i !== 0) {
                let nameIndex = header.indexOf('name'); 
                let name = item[nameIndex];
                tmp.push({
                    name: name,
                });
            }
        });
        if(method ===  'post'){
            if(data?.type === 0){
                setLoading(true);
                axios({
                    method: 'post',
                    url: '/brand',
                    data: tmp,
                }).then(() => {
                    getData();
                    handleCloseFileModal();
                }).catch((err) => {
                }).then(() => setLoading(false))
            } 
            else {
                setLoading(true)
                axios({
                    method: 'post',
                    url: '/brand',
                    data: tmp,
                }).then(() => {
                    getData();
                    handleCloseFileModal();
                }).catch((err) => {
                }).then(() => setLoading(false))
            }
        }
        else {
            if(data?.type === 0){
                setLoading(true);
                axios({
                    method: 'put',
                    url: '/brand',
                    data: tmp,
                }).then(() => {
                    getData();
                    handleOpenCloseModalFileEdit();
                }).catch((err) => {
                }).then(() => setLoading(false))
            }
            else {
                setLoading(true)
                axios({
                    method: 'put',
                    url: '/brand',
                    data: tmp,
                }).then(() => {
                    getData();
                    handleOpenCloseModalFileEdit();
                }).catch((err) => {
                }).then(() => setLoading(false))
            }
        };
    }

    return (
        <TableCard
            header={
                <div className='flex flex-col'>
                    <div className='w-full flex justify-between items-center gap-4'>
                        <h1 className='text-2xl font-medium'>Салбарын жагсаалт</h1>
                        <div className='flex items-center gap-2'>
                            <Button icon={<FaFilter/>} onClick={() => setFilterOpen(true)}>Шүүлтүүр</Button>
                            <Export
                                fileData={data} 
                                fileName={'Салбарын жагсаалт'} 
                            />
                            <Button
                                icon={<PrinterOutlined className=''/>}
                                onClick={handleOpenFile}
                            >Excel оруулах</Button>
                            <Button type='primary' icon={<FaPlus/>}  onClick={handleAddButton}>Нэмэх</Button>
                        </div>          
                    </div>
                </div>
            }
        >
            <Table
                dataSource={data}
                columns={columns}
                loading={loading}
            />
            <Modal title={editData ? 'Засах' : 'Шинээр нэмэх'}    open={showModal} onCancel={handleCloseModal}>
                <Form
                    form={form}
                    fields={fields}
                    editData={editData}
                    onFinish={handleSubmit}
                    className={'gap-2'}
                >
                    <div className='col-span-12 flex justify-end items-center gap-2 mt-5'>
                        <Button type='primary' onClick={() => form.submit()} loading={actionLoading} icon={<SaveOutlined/>}>Хадгалах</Button>
                        <Button onClick={handleCancel} disabled={actionLoading}>Цуцлах</Button>
                    </div>
                </Form>
            </Modal>
            <Drawer
                open={filterOpen}
                onClose={() => setFilterOpen(false)} 
            >
                <div>
                    <h1 className='text-xl text-black-text font-bold'>Шүүх</h1>
                    <Form
                        form={filterForm}
                        fields={searchFields()}
                        onFinish={handleFilterSubmit}
                        className='gap-4'
                    />  
                    <Button className='w-full mt-4' size='sm' type="primary" onClick={() => filterForm.submit()}>Хайх</Button>
                </div>
            </Drawer>
            <Modal
                title={<div className="text-lg uppercase">{'Салбар нэгж excel оруулах'}</div>}
                open={openModalFileEdit}
                onCancel={handleOpenCloseModalFileEdit}
                width={1200}
                destroyOnClose
                footer={false}
            >
                <AntForm
                    form={form}
                    onFinish={(values) => handleFileSubmit(values, 'post')} 
                >
                    <AntForm.Item>
                        <ExcelRender header={header} setHeader={setHeader} cols={cols} setCols={setCols} />
                    </AntForm.Item>
                    <AntForm.Item>
                        <div className="flex justify-end">
                            <Button
                                type="primary"
                                onClick={() => form.submit()}
                                loading={actionLoading}
                                icon={<SaveOutlined />}
                            >
                                Хадгалах
                            </Button>
                        </div>
                    </AntForm.Item>
                </AntForm>
            </Modal>
        </TableCard>
    )
}

export default Branch
